/* models/mappers/categorical_pattern_mapper */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var categorical_mapper_1 = require(172) /* ./categorical_mapper */;
    var mapper_1 = require(180) /* ./mapper */;
    var p = require(18) /* ../../core/properties */;
    var CategoricalPatternMapper = /** @class */ (function (_super) {
        tslib_1.__extends(CategoricalPatternMapper, _super);
        function CategoricalPatternMapper(attrs) {
            return _super.call(this, attrs) || this;
        }
        CategoricalPatternMapper.initClass = function () {
            this.define({
                factors: [p.Array],
                patterns: [p.Array],
                start: [p.Number, 0],
                end: [p.Number],
                default_value: [p.HatchPatternType, " "],
            });
        };
        CategoricalPatternMapper.prototype.v_compute = function (xs) {
            var values = new Array(xs.length);
            categorical_mapper_1.cat_v_compute(xs, this.factors, this.patterns, values, this.start, this.end, this.default_value);
            return values;
        };
        CategoricalPatternMapper.__name__ = "CategoricalPatternMapper";
        return CategoricalPatternMapper;
    }(mapper_1.Mapper));
    exports.CategoricalPatternMapper = CategoricalPatternMapper;
    CategoricalPatternMapper.initClass();
}
